jQuery(function ($) {
  // Set the object URL or current page URL in CF7 forms
  function setFormPageUrl(url) {
    // Find all CF7 forms with object-url field
    $('.wpcf7-form input[name="object-url"]').each(function() {
      $(this).val(url);
    });
  }

  // Set current page URL on page load for all forms
  $(document).ready(function() {
    const currentUrl = window.location.href;
    setFormPageUrl(currentUrl);
  });

  // Update URL when modal opens with specific object URL
  $(document).on('click', '.modal-opener', function (e) {
    const objectUrl = $(this).data('object-url');
    const downloadUrl = $(this).data('download-url');

    // If there's a specific object URL, use it
    if (objectUrl) {
      setFormPageUrl(objectUrl);
    }
    // If it's a brochure download, track the current page
    else if (downloadUrl) {
      const currentUrl = window.location.href;
      setFormPageUrl(currentUrl);
    }
  });

  // Track wishlist form submissions
  $(document).on('click', '.wishlist-container .modal-opener', function(e) {
    // Get all wishlist object URLs
    const wishlistUrls = [];
    $('.wishlist-container .object-item').each(function() {
      const objectId = $(this).data('object-id');
      const objectLink = $(this).find('.entry-link').attr('href');
      if (objectLink) {
        wishlistUrls.push(objectLink);
      }
    });

    // If there are wishlist items, add them to the form
    if (wishlistUrls.length > 0) {
      const wishlistUrlsText = wishlistUrls.join(', ');
      setFormPageUrl(wishlistUrlsText);
    }
  });
});
